module.exports = __webpack_public_path__ + "resources/img/img_table_cell_half.03fde02adae940c42a831052b22135fe.png";